import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, DateTimePicker, getTestId, Input, isValidObject, StateConfigContext, Typography } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { checkAllConditionTrue } from '../sim-declaration/SimDeclarationUtils';
import { aadhaarConfirmationConfig, successAvatarConfig } from './AadhaarConfirmationConfig';
import { getDate, getIsDisabledState, getSubHeading, parseDate } from './AadhaarConfirmationUtils';
export var AadhaarConfirmation = props => {
  var _a;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, aadhaarConfirmationConfig, props), [aadhaarConfirmationConfig, props]),
    state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    testID = _useMemo.testID,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    style = _useMemo.style,
    onUserAction = _useMemo.onUserAction,
    id = _useMemo.id,
    stepDetailsProps = _useMemo.stepDetailsProps,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    inputsDataProps = _useMemo.inputsDataProps,
    dobValue = _useMemo.dobValue,
    _useMemo$prefillYearO = _useMemo.prefillYearOnly,
    prefillYearOnly = _useMemo$prefillYearO === void 0 ? false : _useMemo$prefillYearO,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    onInValidFormMetaData = _useMemo.onInValidFormMetaData;
  var _ref = inputsDataProps || {},
    _ref$dateInput = _ref.dateInput,
    dateInput = _ref$dateInput === void 0 ? {} : _ref$dateInput,
    _ref$fullName = _ref.fullName,
    fullName = _ref$fullName === void 0 ? {} : _ref$fullName,
    _ref$guardianName = _ref.guardianName,
    guardianName = _ref$guardianName === void 0 ? {} : _ref$guardianName,
    _ref$aadhaarAddress = _ref.aadhaarAddress,
    aadhaarAddress = _ref$aadhaarAddress === void 0 ? {} : _ref$aadhaarAddress;
  var skycFormWidgetStyle = getSkycFormWidgetStyles();
  var _useState = useState(aadhaarAddress === null || aadhaarAddress === void 0 ? void 0 : aadhaarAddress.value),
    aadhaarAddressInputValue = _useState[0],
    setAadhaarAddressInputValue = _useState[1];
  var _useState2 = useState(fullName === null || fullName === void 0 ? void 0 : fullName.value),
    fullNameInputValue = _useState2[0],
    setFullNameInputValue = _useState2[1];
  var _useState3 = useState(guardianName),
    guardianNameInputProps = _useState3[0],
    setGuardianNameInputProps = _useState3[1];
  var _useState4 = useState(dateInput),
    dateInputProps = _useState4[0],
    setDateInputProps = _useState4[1];
  var _useState5 = useState(dobValue ? new Date(dobValue) : new Date()),
    dobInputValue = _useState5[0],
    setDobInputValue = _useState5[1];
  var _useState6 = useState(!prefillYearOnly),
    isDateSelected = _useState6[0],
    setIsDateSelected = _useState6[1];
  var _useState7 = useState(!prefillYearOnly),
    isMonthSelected = _useState7[0],
    setIsMonthSelected = _useState7[1];
  var _useState8 = useState(isExpanded),
    isExpandedState = _useState8[0],
    setIsExpandedState = _useState8[1];
  var _useState9 = useState(state),
    stateType = _useState9[0],
    setStateType = _useState9[1];
  var _useState10 = useState((_a = stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading) !== null && _a !== void 0 ? _a : ''),
    subHeading = _useState10[0],
    setSubHeading = _useState10[1];
  var _useState11 = useState(null),
    isCalenderOpen = _useState11[0],
    setIsCalenderOpen = _useState11[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var validateGuardianName = value => {
    var name = value || (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.value);
    var isValid = (name === null || name === void 0 ? void 0 : name.length) >= 3;
    if (typeof (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.validationRegex) === 'string') {
      var guardianNameRegex = new RegExp((guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.validationRegex) || '');
      isValid = isValid && guardianNameRegex.test(name);
    }
    return isValid;
  };
  var handleTextChange = value => {
    setStateType('none');
    setSubHeading('');
    var updatedProps = Object.assign(Object.assign({}, guardianNameInputProps), {
      value
    });
    setGuardianNameInputProps(updatedProps);
    (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onChangeMetaData), Object.assign({}, updatedProps)));
    handleOnValidInputMetaData(value);
  };
  var handleDobChange = (date, isDate) => {
    setStateType('none');
    setSubHeading('');
    if (isDate) {
      setIsDateSelected(true);
      setDobInputValue(date);
    } else {
      setIsMonthSelected(true);
      setDobInputValue(prevDate => {
        var newDate = new Date(prevDate);
        newDate.setMonth(date.getMonth());
        return newDate;
      });
    }
    (dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.onChangeMetaData), Object.assign(Object.assign({}, dateInputProps), {
      value: getDate(date)
    })));
  };
  var handleOnValidInputMetaData = value => {
    if (!validateGuardianName(value)) return;
    (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onValidInputMetaData), Object.assign(Object.assign({}, guardianNameInputProps), {
      value
    })));
  };
  var handleOnPressIn = () => {
    (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onClickMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.onClickMetaData), Object.assign({}, guardianNameInputProps)));
  };
  var debouncedUserAction = useCallback(debounce(onUserAction, autoFormSubmitDebounceDelay), []);
  var handleValidation = () => {
    if (!onUserAction) return;
    var isValidDob = isDateSelected && isMonthSelected;
    var isGuardianNameValid = validateGuardianName();
    var isValidAllData = checkAllConditionTrue(isGuardianNameValid, isValidDob);
    var metaData = isValidAllData ? onValidFormMetaData : onInValidFormMetaData;
    var userActionPayload = [Object.assign({
      id
    }, metaData), Object.assign(Object.assign({
      props
    }, guardianNameInputProps), {
      dob: getDate(dobInputValue)
    })];
    if (!isValidObject(metaData)) return;
    if (isAutoFormSubmitDebounceAllowed) {
      debouncedUserAction(...userActionPayload);
    } else {
      onUserAction(...userActionPayload);
    }
    return isValidAllData;
  };
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  useEffect(() => {
    setStateType(state);
    setIsExpandedState(state === 'none');
  }, [state]);
  useEffect(() => {
    setIsDateSelected(!prefillYearOnly);
    setIsMonthSelected(!prefillYearOnly);
  }, [prefillYearOnly]);
  useEffect(() => {
    setDobInputValue(parseDate(dobValue));
  }, [dobValue]);
  useEffect(() => {
    setSubHeading(stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading);
  }, [stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading]);
  useEffect(() => {
    var _a;
    setFullNameInputValue((_a = fullName === null || fullName === void 0 ? void 0 : fullName.value) !== null && _a !== void 0 ? _a : '');
  }, [fullName === null || fullName === void 0 ? void 0 : fullName.value]);
  useEffect(() => {
    var _a;
    setAadhaarAddressInputValue((_a = aadhaarAddress === null || aadhaarAddress === void 0 ? void 0 : aadhaarAddress.value) !== null && _a !== void 0 ? _a : '');
  }, [aadhaarAddress === null || aadhaarAddress === void 0 ? void 0 : aadhaarAddress.value]);
  useEffect(() => {
    setGuardianNameInputProps(prev => {
      return Object.assign(Object.assign({}, prev), guardianName);
    });
  }, [JSON.stringify(guardianName)]);
  useEffect(() => {
    setDateInputProps(prev => {
      return Object.assign(Object.assign({}, prev), dateInput);
    });
  }, [JSON.stringify(dateInput)]);
  useEffect(() => {
    if (prefillYearOnly && isDateSelected && isMonthSelected) {
      (dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.onValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.onValidInputMetaData), Object.assign(Object.assign({}, dateInputProps), {
        value: getDate(dobInputValue)
      })));
    }
  }, [prefillYearOnly, dobInputValue, isDateSelected, isMonthSelected]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  useEffect(() => {
    if (isDateSelected && isMonthSelected && (guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.value)) {
      handleValidation();
    }
  }, [dobInputValue, isDateSelected, isMonthSelected, guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.value]);
  return isValidObject(stepDetailsProps) && _jsx(Collapsible, Object.assign({
    theme: theme,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    withCard: true,
    removeOverflow: true
  }, getTestId(testID, 'Collapsible'), {
    isExpanded: isExpandedState,
    style: [skycFormWidgetStyle.heading, style],
    disabled: getIsDisabledState(isDisabledState, disableToggle),
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    titleComponent: _jsx(LinkListItemWidget, Object.assign({}, stepDetailsProps, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, {
      roundedCorners: true,
      theme: theme,
      noHoverEffect: true,
      noPressEffect: true,
      onPress: onStepDetailsListItemPressMetaData,
      onUserAction: onUserAction
    }, getTestId(testID, 'LinkListItemWidget'), {
      actionTypeProps: !isExpandedState && !isDisabledState && (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.actionTypeProps),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress
    }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
      subHeading: getSubHeading(subHeading, fullNameInputValue, getDate(dobInputValue, 'dd MMM yyyy'), guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.value)
    }, {
      disabled: getIsDisabledState(isDisabledState, stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.disabled),
      subHeadingNumberOfLines: (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeadingNumberOfLines) || 1
    }))
  }, {
    children: _jsxs(View, Object.assign({
      style: skycFormWidgetStyle.content
    }, {
      children: [_jsx(Input, Object.assign({}, fullName, {
        theme: theme
      }, getTestId(testID, 'fullName_Input'), {
        value: fullNameInputValue,
        containerStyle: skycFormWidgetStyle.inputWidget
      })), isValidObject(aadhaarAddress) && _jsx(Input, Object.assign({}, aadhaarAddress, {
        theme: theme
      }, getTestId(testID, 'aadhaarAddress_Input'), {
        value: aadhaarAddressInputValue,
        containerStyle: skycFormWidgetStyle.inputWidget
      })), _jsx(Typography, Object.assign({
        type: "body-single-line-xs",
        style: skycFormWidgetStyle.label,
        text: dateInput === null || dateInput === void 0 ? void 0 : dateInput.label,
        disabled: !prefillYearOnly
      }, getTestId(testID, 'date_label'))), _jsxs(View, Object.assign({
        style: skycFormWidgetStyle.dateInput
      }, {
        children: [_jsx(View, Object.assign({
          style: [{
            flexGrow: 2,
            flexBasis: 0
          }, isCalenderOpen === 'day' && {
            zIndex: -1
          }]
        }, {
          children: _jsx(DateTimePicker, Object.assign({}, dateInputProps, {
            shouldPrefillDate: isMonthSelected
          }, getTestId(testID, 'month_datetimepicker'), {
            inputProps: Object.assign(Object.assign({}, dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.inputProps), {
              isDisabled: !prefillYearOnly
            }),
            startDate: dobInputValue,
            inputPlaceholder: "Month",
            dateFormat: "MMM",
            showMonthYearPicker: true,
            onChange: date => {
              handleDobChange(date, false);
            },
            onOpen: () => setIsCalenderOpen('month'),
            onClose: () => setIsCalenderOpen(null)
          }))
        })), _jsx(View, Object.assign({
          style: [{
            flexGrow: 1.7,
            flexBasis: 0
          }, isCalenderOpen === 'month' && {
            zIndex: -1
          }]
        }, {
          children: _jsx(DateTimePicker, Object.assign({}, dateInputProps, {
            shouldPrefillDate: isDateSelected
          }, getTestId(testID, 'date_datetimepicker'), {
            inputProps: Object.assign(Object.assign({}, dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.inputProps), {
              isDisabled: !prefillYearOnly
            }),
            startDate: dobInputValue,
            inputPlaceholder: "Day",
            dateFormat: "d",
            onChange: date => {
              handleDobChange(date, true);
            },
            onOpen: () => setIsCalenderOpen('day'),
            onClose: () => setIsCalenderOpen(null)
          }))
        })), _jsx(View, Object.assign({
          style: [{
            flexGrow: 2,
            flexBasis: 0
          }, isCalenderOpen && {
            zIndex: -3
          }]
        }, {
          children: _jsx(DateTimePicker, Object.assign({}, dateInputProps, getTestId(testID, 'year_datetimepicker'), {
            inputProps: Object.assign(Object.assign({}, dateInputProps === null || dateInputProps === void 0 ? void 0 : dateInputProps.inputProps), {
              isDisabled: true
            }),
            startDate: dobInputValue,
            inputPlaceholder: "Year",
            dateFormat: "yyyy",
            showYearPicker: true
          }))
        }))]
      })), _jsx(Input, Object.assign({}, guardianNameInputProps, getTestId(testID, 'guardian_input'), {
        theme: theme,
        isDisabled: getIsDisabledState(isDisabledState, guardianNameInputProps === null || guardianNameInputProps === void 0 ? void 0 : guardianNameInputProps.isDisabled),
        onChangeText: handleTextChange,
        readOnlyOnPress: handleOnPressIn
      }))]
    }))
  }));
};